export default __webpack_public_path__ + "static/media/2.7ba88038.jpg";